import React, { useEffect, useState } from 'react';
import { ArrowRight, Calculator, Clock, Ruler, ShieldCheck, Zap } from 'lucide-react';
import { scrollToSection, viewPortfolio } from '../utils/buttonActions';
import HeroScene from './HeroScene';
import IndustrialButton from './IndustrialButton';

const Hero = () => {
  const [currentWord, setCurrentWord] = useState(0);
  const words = ['Dream.', 'BRAND.', 'CITY.', 'MARKET.', 'STAGE.'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % words.length);
    }, 2400);

    return () => clearInterval(interval);
  }, [words.length]);

  const stats = [
    { icon: <ShieldCheck className="h-5 w-5" strokeWidth={2} />, number: '25+', label: 'YEARS ACTIVE' },
    { icon: <Ruler className="h-5 w-5" strokeWidth={2} />, number: '1000+', label: 'PROJECTS DONE' },
    { icon: <Zap className="h-5 w-5" strokeWidth={2} />, number: '1440', label: 'DPI READY' },
    { icon: <Clock className="h-5 w-5" strokeWidth={2} />, number: '2 HR', label: 'FAST CALLBACK' },
  ];

  return (
    <section id="home" className="hero-section relative overflow-hidden border-b-2 border-[#0A0A0A]" data-testid="hero-section">
      <div className="industrial-grid-bg" aria-hidden="true" />
      <div className="hero-marquee" aria-hidden="true">
        <span>AIM FLEX / PRINT CONTROL / MADURAI / SIGNAGE / VINYL / FLEX / </span>
        <span>AIM FLEX / PRINT CONTROL / MADURAI / SIGNAGE / VINYL / FLEX / </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-[0.92fr_1.08fr] gap-10 lg:gap-14 items-center">
          <div className="space-y-8" data-reveal>
            <div className="hero-chip inline-flex items-center gap-3 border-2 border-[#0A0A0A] bg-white px-4 py-2 shadow-brutal-sm">
              <span className="h-2.5 w-2.5 bg-[#FF2A00]" />
              <span className="hero-chip-label text-[11px] font-black tracking-[0.2em] uppercase">Aim Flex - The Printing People</span>
            </div>

            <div>
              <h1 className="hero-title" data-testid="hero-heading">
                <span className="block">YOUR <span className="hero-word">Vision.</span></span>
                <span className="block">YOUR <span className="hero-word">{words[currentWord]}</span></span>
                <span className="block">OUR <span className="hero-word">CRAFT.</span></span>
              </h1>
              <p className="hero-copy mt-6 max-w-xl text-base md:text-lg text-[#303030] leading-relaxed">
                OUR CRAFT turns bold ideas into street-level presence with flex, vinyl, branding, and fabrication built for real businesses in Madurai.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <IndustrialButton onClick={() => scrollToSection('smart-quote')} testId="hero-quote-btn">
                <Calculator className="mr-2 h-4 w-4" strokeWidth={2} />
                Start Smart Quote
                <ArrowRight className="ml-2 h-4 w-4" strokeWidth={2} />
              </IndustrialButton>
              <IndustrialButton onClick={() => viewPortfolio()} variant="light" testId="hero-portfolio-btn">
                View Portfolio
              </IndustrialButton>
            </div>

            <div className="hero-proof-grid">
              {stats.map((stat, index) => (
                <div key={index} className="hero-proof-cell" style={{ '--delay': `${index * 80}ms` }}>
                  <div className="text-[#FF2A00] mb-3">{stat.icon}</div>
                  <div className="text-3xl font-black tracking-tighter text-[#0A0A0A]">{stat.number}</div>
                  <p className="text-[10px] font-black tracking-[0.18em] text-[#666] uppercase mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative min-h-[520px] lg:min-h-[620px]" data-reveal>
            <HeroScene />
            <div className="hero-floating-ticket">
              <span>LIVE ESTIMATE</span>
              <strong>Rs.10 - Rs.85 / sq ft</strong>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollToSection('services')}
        className="hero-scroll-indicator"
        aria-label="Scroll to services"
        data-testid="scroll-indicator"
      >
        <span />
      </button>
    </section>
  );
};

export default Hero;
